export const required = 'Поле обязательно для заполнения'
export const minLength = (minLength: number) => `Поле должно содержать минимум ${minLength} символов`
